import { setSelectedConstraintTab } from "../../store/constraint";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { ConstraintTabBarType } from "../../types/constraint";
import labels from "../../utils/labels";
import ViewTabsWrapper from "../UI/tab/ViewTabsWrapper";
import ViewTab from "../UI/tab/ViewTab";

const constraintTabLabels: Record<ConstraintTabBarType, string> = {
  Employee: labels.employees,
  Citizens: labels.citizens,
  Categories: labels.categoryConstraints,
};

const ConstraintTabBar = () => {
  const dispatch = useAppDispatch();
  const { selectedConstraintTab } = useAppSelector(
    (state) => state.constraintSlice,
  );

  const tabRow: ConstraintTabBarType[] = ["Employee", "Citizens", "Categories"];

  return (
    <ViewTabsWrapper>
      {tabRow.map((tab) => (
        <ViewTab
          key={tab}
          selected={selectedConstraintTab}
          onClick={() => {
            dispatch(setSelectedConstraintTab(tab));
          }}
          tabTypeName={tab}
          displayedTabName={constraintTabLabels[tab]}
        />
      ))}
    </ViewTabsWrapper>
  );
};

export default ConstraintTabBar;
